import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P19-E1",
    audio: "img/FriendsPlus/Page19/Audio/audio-e1-p19.mp3",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page19/E1/Key/answerKey.png",
    stylesTextInput: { borderBottomWidth: 0, backgroundColor: 'transparent' },
    inputSize: 34,
    maxLength: 1,
    textAlign: "center",
    titleImage: "",
    titleQuestion: [
      {
        color: "#23408f",
        num: "1",
        title:
          'Listen and number. <headphone name="26" src="img/FriendsPlus/Page19/Audio/tieude-e1-p19.mp3"></headphone>',
      },
    ],
    questionImage: [],
    questions: [
      {
        title: `
          <div style='display: flex; flex-direction: row;position: relative;'>
            <img src="img/FriendsPlus/Page19/E1/title.jpg" style="width: 100%">
            <div style='position: absolute;top: 62px;left: 32px;'>#</div>
            <div style='position: absolute;top: 248px;left: 62px;'>#</div>
            <div style='position: absolute;top: 37px;left: 478px;'>#</div>
            <div style='position: absolute;top: 139px;left: 568px;'>#</div>
            <div style='position: absolute;top: 110px;left: 654px;'>#</div>
          </div>
        `,
        answer: ["5", "3", "4", "2", "6"],
      },
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P19-E2",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page19/E2/1.jpg" }]],
  },
  3: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P19-E3",
    audio: "",
    video: "",
    component: D1,
    // recorder: true,
    isAllowSubmit: false,
    hideBtnFooter: true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page19/E3/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page19/E3/2.jpg" },
        { url: "img/FriendsPlus/Page19/E3/3.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page19/E3/4.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page19/E3/5.jpg" },
        { url: "img/FriendsPlus/Page19/E3/6.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page19/E3/7.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page19/E3/8.jpg" },
        { url: "img/FriendsPlus/Page19/E3/9.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page19/E3/10.jpg" },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page19/E3/11.jpg" },
        { url: "img/FriendsPlus/Page19/E3/12.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page19/E3/13.jpg" },
      ],
      [
        // Column6
        { url: "img/FriendsPlus/Page19/E3/14.jpg" },
        { url: "img/FriendsPlus/Page19/E3/15.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page19/E3/16.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page19/E3/17.jpg" }],
    ],
  },
  4: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P19-E4",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page19/E4/1.jpg" }],
      [{ url: "img/FriendsPlus/Page19/E4/2.jpg" }],
      [{ url: "img/FriendsPlus/Page19/E4/3.jpg" }],
      [{ url: "img/FriendsPlus/Page19/E4/4.jpg" }],
    ],
  },
};

export default json;
